export const fetchTodaySchedule = async (accessToken) => {
    const calendarId = 'mvla.net_3236303434383738363838@resource.calendar.google.com';
    const API_KEY = 'AIzaSyBo3O6QfsaaL6U-pV2KCnfk1LGORmAB8V8';

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const timeMin = today.toISOString();

    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const timeMax = tomorrow.toISOString();

    console.log('Fetching calendar for today:', timeMin, 'to', timeMax);
    console.log('Access token available:', !!accessToken);

    try {
        // Build URL with API key as fallback
        const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(calendarId)}/events?timeMin=${timeMin}&timeMax=${timeMax}&singleEvents=true&key=${API_KEY}`;

        // Include OAuth token in headers if available
        const headers = accessToken
            ? { Authorization: `Bearer ${accessToken}` }
            : {};

        const response = await fetch(url, { headers });
        const data = await response.json();

        console.log('Calendar API response:', data);

        if (data.items && data.items.length > 0) {
            const scheduleEvent = data.items.find(event =>
                event.summary && event.summary.toLowerCase().includes('schedule')
            );

            if (scheduleEvent) {
                console.log('Found schedule event:', scheduleEvent);
                const trimmedScheduleType = scheduleEvent.summary.replace(/\s*\([^)]*\)/g, '').trim();
                return {
                    scheduleType: trimmedScheduleType,
                    description: scheduleEvent.description || '',
                    startTime: scheduleEvent.start.dateTime || scheduleEvent.start.date,
                    endTime: scheduleEvent.end.dateTime || scheduleEvent.end.date
                };
            }
        }

        console.log('No schedule events found');
        return null;
    } catch (error) {
        console.error('Error fetching calendar:', error);
        return null;
    }
};